import { Pipe, PipeTransform } from '@angular/core';
import Utils from '../utils/utils';

@Pipe({ name: 'StringHqDate' })
export class StringHqDatePipe implements PipeTransform {

  transform(val: any): any {
    return Utils.stringHQDate(val);
  }

}
